import { useState, useEffect } from 'react';
import * as userRoles from '../config/userRoles';

export const getPermissions = () => {
    const permissions = localStorage.getItem('permissions')?.split(',') || [];
    return {
        isLegalUser: permissions.includes(userRoles.ROLE_LEGAL_USER),
        isLegalAdmin: permissions.includes(userRoles.ROLE_LEGAL_ADMIN),
        isLegalTVAdmin: permissions.includes(userRoles.ROLE_TV_LEGAL_ADMIN),
        isProductCommentsAdmin: permissions.includes(userRoles.ROLE_PRODUCT_COMMENTS_ADMIN),
    };
};

export function usePermissions() {
    const [perms, setPerms] = useState(getPermissions());

    useEffect(() => {
        const handleStorage = (e) => {
            if (e.key === 'permissions') {
                setPerms(getPermissions());
            }
        };
        window.addEventListener('storage', handleStorage);
        // Also update on mount in case permissions changed before mount
        setPerms(getPermissions());
        return () => window.removeEventListener('storage', handleStorage);
    }, []);

    return perms;
}